import type { FC } from 'react';

import { CheckCircle as Component } from '@untitledui-pro/icons/solid/CheckCircle';

import { BaseIcon, type IconProps } from '../../base-icon/base-icon.tsx';

export type CheckCircleProps = IconProps;

export const CheckCircle: FC<CheckCircleProps> = (props) => <BaseIcon {...props} Component={Component} />;
